(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/engine/assets/javascripts/utils/make-systems-list.js') >= 0) return;  svs.modules.push('/components/tipsen/engine/assets/javascripts/utils/make-systems-list.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
let RSYSTEMS;
let USYSTEMS;
if (svs.isServer) {
  RSYSTEMS = require('../../../../../sport/systems/api').RSYSTEMS;
  USYSTEMS = require('../../../../../sport/systems/api').USYSTEMS;
} else {
  RSYSTEMS = svs.components.sport.systems.RSYSTEMS;
  USYSTEMS = svs.components.sport.systems.USYSTEMS;
}
const blacklistedSystemsForTipsen = ['R8-3-504', 'R9-0-1356', 'U8-3-171'];
const makeSystemsList = systemType => {
  const system = {
    R: RSYSTEMS,
    U: USYSTEMS
  }[systemType];
  if (!system) {
    throw new Error("Unsupported system: ".concat(systemType));
  }
  return Object.keys(system).filter(systemNum => !blacklistedSystemsForTipsen.includes(system[systemNum])).sort((sysA, sysB) => {
    const _system$sysA$match$ma = system[sysA].match(/(\d+)/g).map(Number),
      _system$sysA$match$ma2 = _slicedToArray(_system$sysA$match$ma, 3),
      aFull = _system$sysA$match$ma2[0],
      aHalf = _system$sysA$match$ma2[1],
      aTot = _system$sysA$match$ma2[2];
    const _system$sysB$match$ma = system[sysB].match(/(\d+)/g).map(Number),
      _system$sysB$match$ma2 = _slicedToArray(_system$sysB$match$ma, 3),
      bFull = _system$sysB$match$ma2[0],
      bHalf = _system$sysB$match$ma2[1],
      bTot = _system$sysB$match$ma2[2];
    return aFull - bFull || aHalf - bHalf || aTot - bTot;
  }).map(Number);
};
if (svs.isServer) {
  module.exports = makeSystemsList;
} else {
  setGlobal('svs.components.tipsen.engine.utils.makeSystemsList', makeSystemsList);
}

 })(window);